module.exports = __webpack_public_path__ + "img/ZNZBZZYJC_4.a50a3e6d.jpg";